export function safe(
    literals: TemplateStringsArray,
    ...placeholders: Array<string | number>
): string {
    let result = '';

    for (let i = 0; i < placeholders.length; i++) {
        result += literals[i];

        const placeholder = placeholders[i];
        if (typeof placeholder === 'number') {
            result += `${placeholder}`;
        } else {
            result += placeholder;
        }
    }

    result += literals[literals.length - 1];
    return result;
}
